import React, { useState } from "react";
import Modal from "./Modal";
import { Button, Input, Select } from "../Form";
import { BiChevronDown } from "react-icons/bi";
import { sortsDatas } from "../Datas";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { toast } from "react-hot-toast";
import Access from "../Access";
import Uploader from "../Uploader";
import { createDoctor } from "../../api/doctor";

function AddDoctorModal({ closeModal, isOpen, doctor, datas }) {
	const [instraction, setInstraction] = useState(sortsDatas.title[0]);
	const [access, setAccess] = useState({});
	const [name, setName] = useState("");
	const [clinicName, setClinicName] = useState("");
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [website, setWebsite] = useState("");
	const [address, setAddress] = useState("");
	const [loading, setLoading] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!email.trim()) {
		  toast.error("Email is required");
		  return;
		}
	
		const data = {
		  name: name,
		  clinicName: clinicName,
		  email: email,
		  phone: phone,
		  website: website,
		  address: address
		};
	
		setLoading(true);
		const response = await createDoctor(data);
		if (response) {
		  setLoading(false);
		  setName("");
		  setClinicName("");
		  setEmail("");
		  setPhone("");
		  setWebsite("");
		  setAddress("");
		//   navigate("/");
		closeModal()
		}
		setLoading(false);
	  };

	return (
		<Modal
			closeModal={closeModal}
			isOpen={isOpen}
			title={doctor ? "Add Doctor" : datas?.id ? "Edit Stuff" : "Add Stuff"}
			width={"max-w-3xl"}>
			<div className="flex-colo gap-2">
				<Input label={'Name'} name={'name'} color placeholder={'Name'} type={'text'} value={name} onChange={(e) => setName(e.target.value)} />
				<Input label="Clinic Name *" color placeholder="Clinic Name" type={'text'} value={clinicName} onChange={(e) => setClinicName(e.target.value)}/>
				<Input label="Email *" color placeholder="Email" type={'text'} value={email} onChange={(e) => setEmail(e.target.value)}/>
				<Input label="Phone" color placeholder="Phone" type={'text'} value={phone} onChange={(e) => setPhone(e.target.value)}/>
				<Input label="Website" color placeholder="Website" type={'text'} value={website} onChange={(e) => setWebsite(e.target.value)}/>
				<Input label="Address" color placeholder="Address" type={'text'} value={address} onChange={(e) => setAddress(e.target.value)}/>
				{/* buttones */}
				<div className="grid sm:grid-cols-2 gap-4 w-full">
					<button
						onClick={closeModal}
						className="bg-red-600 bg-opacity-5 text-red-600 text-sm p-4 rounded-lg font-light">
						Cancel
					</button>
					<Button label="Save" Icon={HiOutlineCheckCircle} onClick={handleSubmit} />
				</div>
			</div>
		</Modal>
	);
}

export default AddDoctorModal;
